<section class="product-tax-container">
  <div class="container-title">
    {{ 'text_productTax' | dbText }}
  </div>
  <div class="stax-status-container">
    <div class="field-label">
      {{ 'text_taxClass' | dbText }} {{taxClassForm.get('slug').valueChanges|async}}
    </div>
    <ds-dropdown
      [dsDropdownPlaceHolder]="!!taxDropdown?.length ? ('text_chooseTaxClass' | dbText) : ('text_noTaxClassAvailable' | dbText)"
      [value]="taxClassForm.get('slug').valueChanges|async"
      (onFullOptionChoose)="onOptionSelect($event)"
      [dsDropdownOptions]="taxDropdown">
    </ds-dropdown>
  </div>
</section>
